import { render, staticRenderFns } from "./Payclass.vue?vue&type=template&id=1f2d811e"
import script from "./Payclass.vue?vue&type=script&lang=js"
export * from "./Payclass.vue?vue&type=script&lang=js"
import style0 from "./Payclass.vue?vue&type=style&index=0&id=1f2d811e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports